/**
 * Loại chứng từ load lên tại combo màn Tổng hợp chứng từ cùng loại
 * Load lên tất cả các loại chứng từ theo Load lên danh mục Loại chứng từ tại sheet Tổng hợp CT cùng loại:   $/MISA.Bamboo/01. Business Analyst/1. Requirement/0. Detail Design/0. Danh mục/DM Loại chứng từ mang đi.xlsx
 */
export default {
  // Phiếu thu
  CAReceipt: 20,
  // Phiếu chi
  CAPayment: 21,
  // Nộp tiền Kho bạc
  BADeposit: 30,
  // Rút tiền Kho bạc
  BUTreasuryWithdrawal: 31,
  // Chuyển tiền nội bộ
  BAInternalTransfer: 32,
  // Chi tiền gửi
  BAWithDraw: 33,
  // Chuyển khoản kho bạc
  BUTransfer: 34,
  // Chuyển khoản kho bạc vào tài khoản tiền gửi
  BUTransferDeposit: 165,
  //Nhập kho: Nhập khác + Nhập mua bằng tiền mặt + Nhập mua bằng tiền gửi
  InInventory: 606263,
  // Phiếu xuất kho
  INOutward: 61,
  // Chuyển kho
  InventoryTransfer: 64,
  // Phiếu ghi tăng TSCĐ
  FixedAssetIncrement: 70,
  // Phiếu ghi giảm TSCĐ
  FixedAssetDecrement: 71,
  // Phiếu điều chỉnh TSCĐ
  FixedAssetAdjustment: 72,
  // Khấu hao TSCĐ
  FixedAssetDepreciation: 73,
  // Phiếu ghi tăng CCDC
  ToolIncrement: 74,
  // Phiếu ghi giảm CCDC
  ToolDecrement: 75,
  // Phiếu điều chuyển CCDC
  ToolTransfer: 77,
  // Hạch toán chi phí lương
  GlPayrollExpense: 81,
  // Chứng từ nghiệp vụ khác
  SUGeneralVoucher: 100,
  // Phiếu kết chuyển tài khoản
  SUAccountTransfer: 101,
  // Nhận dự toán đầu năm
  BUReceiveBudgetPlan: 154,
  // Nhận dự toán bổ sung
  BUReceiveBudgetPlanSupplement: 155,
  // Điều chỉnh dự toán
  BUPlanAdjustment: 156,
  // Hủy dự toán
  BUPlanCancel: 157,
};
